
import React from 'react';
import AllAssetTransactions from './AllAssetTransactions'

const Assettransaction = () => {
    return <AllAssetTransactions />
}

export default Assettransaction;